<template>
  <div>
    <!-- Documents Grid -->
    <div class="documents-grid">
        
      <div v-for="item in documents" :key="item.id">
        <single-document :document="item" @download="downloadDocument"></single-document>
      </div>      
        
    </div>

  </div>
</template>

<script>
import SingleDocument from './SingleDocument'

export default {
  props: ["documents"],
  components: {
    SingleDocument
  },
  data() {
    return {
      showModal: false,
      currentDocumentURL: ''
    }
  },
  methods: {
    downloadDocument(documentURL) {
      window.open(documentURL, "_blank")
    }
  }
}
</script>

<style>
.documents-grid {
  display: grid;
  justify-content: space-evenly;
  padding: 30px;
  gap: 2rem;
  /* grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); */
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
}

/* iframe classes */
.iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}

.document-modal-footer {
  padding: 1rem 1rem 1rem 0;
}

.document-modal-body {
  padding: 0;
  background-color: black;
}

</style>